/** Matches the sign-off already used server-side in clientPriceList.controller.js's send(). */
export const CLIENT_PRICE_LIST_COMPANY_NAME = 'USC Automate Team';

export interface ClientPriceListEmailTemplateParams {
  clientName?: string | null;
  link: string;
  companyName?: string;
}

/**
 * Default email body for sharing a Client Price List. Regenerated by "Restore Default"
 * with the latest name/link so it never goes stale even after the user edits it.
 */
export function buildDefaultClientPriceListEmailDescription({
  clientName,
  link,
  companyName = CLIENT_PRICE_LIST_COMPANY_NAME,
}: ClientPriceListEmailTemplateParams): string {
  const greetingName = (clientName || '').trim() || 'Client';
  return `Dear ${greetingName},

Please find your latest price list attached.

You can also access it online using the secure link below:

${link}

Please let us know if you have any questions.

Best regards,
${companyName}`;
}

/**
 * Guarantees the outgoing email carries the client link even if the user edited
 * it out of the description while customizing the message.
 */
export function ensureClientPriceListLinkPresent(description: string, link: string): string {
  if (!link || description.includes(link)) return description;
  const trimmed = description.trimEnd();
  return `${trimmed}${trimmed ? '\n\n' : ''}${link}`;
}
